function editorPasteHTML(input) {
  let inputString = input;

  // remove everything within style tags
  const styleRegex = /style="(.*?)"/gm;
  inputString = inputString.replace(styleRegex, "");

  // remove any id attributes
  inputString = inputString.replace(/id="(.*?)"/gm, "");

  // remove any class attributes
  inputString = inputString.replace(/class="(.*?)"/gm, "");

  // // remove any data attributes
  // inputString = inputString.replace(/data-(.*?)="(.*?)"/gm, "");

  // // replace 3 or more BR with one BR
  // inputString = inputString.replace("(?:\\s*<br[/\\s]*>\\s*){3,}", "");

  // // remove empty p tags
  // inputString = inputString.replace(/<p>\\s*</p>|<p>\\s*​\\?</p>/g, "");
  
  // remove font tags
  inputString = inputString.replace(/<font[^><]*>|<.font[^><]*>/g, "");

  // remove span tags
  inputString = inputString.replace(/<span[^><]*>|<.span[^><]*>/g, "");

  const dom = new DOMParser().parseFromString(inputString, "text/html");
  let output = dom.querySelector('body').innerHTML;

  // typically autoadded by browser
  output = output.replace("<!--StartFragment-->","");
  output = output.replace("<!--EndFragment-->","");

  return output;
}

export { editorPasteHTML }